module.exports = __webpack_public_path__ + "media/images/photos-btn-976420a1ebe15c25a2dd3c5286544eee.png";